import { render, staticRenderFns } from "./modalSaveWarning.vue?vue&type=template&id=246d70b4&"
import script from "./modalSaveWarning.vue?vue&type=script&lang=js&"
export * from "./modalSaveWarning.vue?vue&type=script&lang=js&"
import style0 from "./modalSaveWarning.vue?vue&type=style&index=0&id=246d70b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports